export default {
  state: {
    approval_status: '2'
  },

  mutations: {
    SET_ACTIVE: (state, data) => {
      state.approval_status = data
    },
  },
  actions: {

  }
}
